'use strict'

import React from 'react';
import FormattedContent from './FormattedContent.jsx';

class ActivityStatusOld extends React.Component {
  render() {
    let statusColor=this.props.status==="done"
      ? "#4b9e39"
      : this.props.status==="inProgress"
        ? "#fed400"
        : undefined;
    return (
      <a style={{color:"black", textDecoration:"none", margin:10}} href={this.props.url}>
        <div style={{color:this.props.status==="notSupported" ? "lightgrey" : "black", marginBottom:40, textAlign:"center", padding:15, borderRadius:50, border:"solid grey 2px", backgroundColor:statusColor}}>
          <div style={{textAlign:"center", width:225, height:40, display:"table-cell", verticalAlign:"middle"}}>{this.props.title!==undefined ? this.props.title : ".("+this.props.name+")"}</div>
        </div>
      </a>
    );
  }
}

class ActivityStatusChecklist extends React.Component {
  constructor(props) {
    super(props);
    this.state={showHelp:false};
  }

  toggleHelp(event) {
    event.preventDefault();
    this.setState({showHelp: !this.state.showHelp});
  }

  render() {
    let statusColor=this.props.status==="done"
      ? "#4b9e39"
      : this.props.status==="inProgress"
        ? "#fed400"
        : undefined;
    return (
      <div style={{width: "48%", paddingBottom: 15}}>
        <span style={{display: "inline-block", verticalAlign: "bottom", borderRadius: "50%", border: "solid 1px "+(this.props.status==="notSupported" ? "lightgrey" : "black"), width:"1em", height:"1em", backgroundColor:statusColor}}> </span>
        <span> </span>
        <a style={{color:this.props.status==="notSupported" ? "lightgrey" : "black"}} href={this.props.url}>{this.props.title!==undefined ? this.props.title : ".("+this.props.name+")"}</a>
        {this.props.help!==undefined ? (
          <span style={{paddingLeft: 10, fontWeight: "normal", cursor: "pointer"}} onClick={this.toggleHelp.bind(this)}><img src="/icons/help.png"/></span>
        ) : null}
        {this.state.showHelp ? (
          <div style={{paddingLeft: 10, paddingTop:5, paddingBottom: 5, fontStyle:"italic"}}>
            <FormattedContent value={this.props.help}/>
          </div>
        ) : null}
      </div>
    );
  }
}

class ActivityStatus extends React.Component {
  render() {
    return (false) ? (
      <ActivityStatusOld {...this.props}/>
    ) : (
      <ActivityStatusChecklist {...this.props}/>
    );
  }
}

export default class ProcessView extends React.Component {
  render() {
    let labels=this.props.labels;
    let activities=this.props.value.activities;
    return (
      <div style={{fontFamily:"Lato, Arial"}}>
        <div style={{maxWidth:1016, marginLeft:60, paddingTop:10, display:"flex", flexWrap:"wrap", justifyContent: "space-between"}}>
          {activities.map(activity=>(
            <ActivityStatus
              key={activity.name}
              name={activity.name}
              title={labels!==undefined && labels.activities[activity.name]!==undefined ? labels.activities[activity.name].title : undefined}
              help={labels!==undefined && labels.activities[activity.name]!==undefined ? labels.activities[activity.name].help : undefined}
              status={activity.status}
              url={(this.props.project.isProgramme ? "/programmes/" : "/projects/")+this.props.project.id+
                activity.link}
            />
          ))}
        </div>
        <div style={{display: "flex", paddingTop: 25, marginRight: 80, justifyContent: "space-between"}}>
          {this.props.value.cancel!==undefined ? (
            <div style={{paddingTop:10}}>
              <a style={{color: "black"}} href={this.props.value.cancel.link}>{labels!==undefined && labels.cancel!==undefined ? labels.cancel.title : ".(cancel)"}</a>
            </div>
          ) : <div/>}
          {this.props.value.nextStep!==undefined ? (
            <div>
              <a style={{color:"black", textDecoration:"none"}} href={this.props.value.nextStep.link}>
                <div style={{
                textAlign:"center",
                border: "2px solid #2B809D",
                backgroundColor:"#ffffff",
                borderRadius: 8,
                color: "#266980",
                height:40,
                fontFamily:"Lato, Arial",
                fontSize:"19px",
                fontWeight:"bold",
                padding:"5px",
                paddingLeft: "20px",
                paddingRight: "20px",
                lineHeight: "23px",
                boxSizing: "border-box",

                position:"relative"}}>

                  <div>{labels!==undefined && labels.nextStep!==undefined ? labels.nextStep.title : ".(nextStep)"}</div>
                </div>
              </a>
            </div>
          ) : <div/>}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/components/ProcessView.jsx